import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import blckslogo from '../assets/icons/BLCKS_LOGO_NEW.svg';
import circlecheckdarkgrey from '../assets/icons/circle-check_darkgrey_2.svg';
import clockicon from '../assets/icons/clock.svg';


export default function ContactThankYou() {
  const [searchParams] = useSearchParams();
  const isConfirmed = searchParams.get('confirmed') === 'true';
  const isPending = searchParams.get('pendingConfirmation') === 'true';
  
  useEffect(() => {
    // Optional: Add tracking or analytics here
    if (isConfirmed) {
      // Track successful confirmation
      console.log('Email confirmed');
    } else if (isPending) {
      // Track pending confirmation
      console.log('Waiting for email confirmation');
    } else {
      // Direct access to thank you page (without going through the flow)
      console.log('Direct access to thank you page');
    }
  }, [isConfirmed, isPending]);
  
  // Navigation remains visible as per user request

  return (
    <div className="min-h-screen bg-[#000000] flex flex-col items-center justify-center p-4">
      <div className="bg-[#0a0a0a] p-8 rounded-lg border border-[#1e1e1e] max-w-md w-full text-center">
        {/* Logo NEW */}
        <div className="mb-6">
          <div className="relative h-8 w-32 mx-auto mb-6">
            <img 
              src={blckslogo} 
              alt="BLCKS AI Logo" 
              className="h-full w-auto mx-auto"
            />
          </div>
          <div className="h-px w-96 bg-[#1e1e1e] mx-auto"></div>
        </div>
        
        {/* Checkmark Icon */}
        <div className="mb-4">
          <div className="relative h-24 w-24 mx-auto mb-4">
            <img 
              src={isConfirmed ? circlecheckdarkgrey : clockicon}
              alt={isConfirmed ? "Bestätigt" : "Warten auf Bestätigung"}
              className="h-full w-auto mx-auto"
            />
          </div>
        </div>
        
        <h1 className="text-2xl font-medium text-white mb-6 font-sans">
          {isConfirmed ? 'E-Mail bestätigt!' : 'Vielen Dank!'}
        </h1>
        
        <p className="text-[#A0A0A0] mb-8 font-sans text-sm max-w-[380px] mx-auto">
          {isConfirmed 
            ? 'Ihre E-Mail-Adresse wurde erfolgreich bestätigt. Wir werden uns in Kürze bei Ihnen melden.'
            : 'Ihre Anfrage ist erfolgreich bei uns eingegangen.'}
        </p>

        {/* What's Next Section */}
        <div className="bg-[#1a1a1a] p-6 rounded-lg mb-8 text-left">
          <p className="text-sm text-[#ffffff] mb-4 font-sans">Wie geht es weiter?</p>
          <ul className="text-sm text-[#A0A0A0] space-y-3 font-sans">
            {!isConfirmed && (
              <li className="flex items-start">
                <span className="text-[#A0A0A0] mr-3 font-mono">1.</span>
                <span>Bestätigen Sie Ihre E-Mail-Adresse über den Link in Ihrer Inbox um sicherzustellen das unsere Antwort nicht in Ihrem Spam-Ordner landet</span>
              </li>
            )}
            <li className="flex items-start">
              <span className="text-[#A0A0A0] mr-3 font-mono">{isConfirmed ? '1.' : '2.'}</span>
              <span>Unser Team prüft Ihre Anfrage</span>
            </li>
            <li className="flex items-start">
              <span className="text-[#A0A0A0] mr-3 font-mono">{isConfirmed ? '2.' : '3.'}</span>
              <span>Wir melden uns zeitnah bei Ihnen mit einer persönlichen Rückmeldung</span>
            </li>
          </ul>
        </div>
        
        <a 
          href="/" 
          className="inline-block bg-white text-[#000000] px-6 py-3 rounded-md font-medium hover:bg-gray-200 transition-colors font-sans"
        >
          Zurück zur Startseite
        </a>

        {/* Footer */}
        <div className="mt-8 pt-6 border-t border-[#1e1e1e] text-center">
          <p className="text-xs text-[#A0A0A0] mb-2 font-sans">Haben Sie weitere Fragen?</p>
          <a 
            href="mailto:hello@blcks.at" 
            className="text-sm text-white hover:underline font-sans"
          >
            hello@blcks.at
          </a>
          <p className="text-xs text-[#A0A0A0] mt-4 font-sans">
            © 2025 BLCKS. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </div>
  );
}
